import React from 'react';
import './About.css';
import rocketGif from '../../assets/rocket.gif';
import visionGif from '../../assets/vision.gif';
import company from '../../assets/company.gif';
import { Helmet } from "react-helmet-async";
const About = () => {
  return (
    <>
    <Helmet>
        <title>About Us | Nifty10</title>
        <meta
          name="description"
          content="Learn more about Nifty10, our mission, and how we're transforming stock market gaming with innovative prediction games."
        />
      </Helmet>
      {/* About Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Us</h1>
          <p>Your vision, our innovation — crafting digital success together.</p>
        </div>
      </section>

      {/* Main About Section */}
      <section className="about-content container">
        <div className="card">
          <img src={company} alt="Rocket" className="card-icon" />
          <h2>Company</h2>
          <p>
            We turn ideas into reality through a focused development process. Our team works together to build strong, scalable software with a passion for quality and innovation in every detail.
          </p>
        </div>

        <div className="card">
          <img src={rocketGif} alt="Rocket" className="card-icon" />
          <h2>Mission</h2>
          <p>
            Our mission is not just to meet expectations but to exceed them. We embrace challenges as
            opportunities for growth, and our commitment to excellence is evident in every line of code
            we write and every pixel we design.
          </p>
        </div>

        <div className="card">
          <img src={visionGif} alt="Vision" className="card-icon" />
          <h2>Vision</h2>
          <p>
            We envision a future where innovation meets execution. We strive to be a trusted partner in
            digital transformation, delivering value through creativity, technology, and strategic thinking.
          </p>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="container">
          <h2>Why Choose Nifty10?</h2>
          <div className="reasons">
            <div className="reason-card">
              <img src="https://img.icons8.com/color/96/checked--v1.png" alt="Expert Team" />
              <h3>Expert Team</h3>
              <p>Our experienced professionals ensure high-quality delivery with innovative thinking.</p>
            </div>
            <div className="reason-card">
              <img src="https://img.icons8.com/?size=160&id=124060&format=png" alt="Fast Delivery" />
              <h3>Agile & Fast</h3>
              <p>We follow agile methodologies to deliver scalable and timely solutions.</p>
            </div>
            <div className="reason-card">
              <img src="https://img.icons8.com/color/96/customer-support.png" alt="Support" />
              <h3>24/7 Support</h3>
              <p>We stand by your side round the clock to provide support and assistance.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
